var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1448_136694)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 12C21 16.9705 16.9705 21 12 21C7.0295 21 3 16.9705 3 12C3 7.0295 7.0295 3 12 3C16.9705 3 21 7.0295 21 12Z",
    fill: "url(#paint0_radial_1448_136694)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 12C20.5 16.6944 16.6944 20.5 12 20.5C7.30564 20.5 3.5 16.6944 3.5 12C3.5 7.30564 7.30564 3.5 12 3.5C16.6944 3.5 20.5 7.30564 20.5 12Z",
    stroke: "#F6C64E",
    strokeOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 17.5C12.8284 17.5 13.5 16.7165 13.5 15.75C13.5 14.7835 12.8284 14 12 14C11.1716 14 10.5 14.7835 10.5 15.75C10.5 16.7165 11.1716 17.5 12 17.5Z",
    fill: "#7B481A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5005 8.5C18.348 8.5 18.1985 8.431 18.1 8.3C16.78 6.5395 15.0695 6.501 14.997 6.5C14.722 6.497 14.5 6.272 14.5015 5.9975C14.503 5.722 14.725 5.5 15 5.5C15.092 5.5 17.2685 5.525 18.9 7.7C19.066 7.921 19.021 8.2345 18.8 8.4C18.71 8.4675 18.605 8.5 18.5005 8.5ZM5.49948 8.5C5.39548 8.5 5.28998 8.4675 5.19998 8.4C4.97898 8.2345 4.93448 7.921 5.09998 7.7C6.73098 5.525 8.90797 5.5 8.99997 5.5C9.27597 5.5 9.49997 5.724 9.49997 6C9.49997 6.2755 9.27747 6.499 9.00197 6.5C8.92447 6.501 7.21798 6.543 5.89998 8.3C5.80198 8.431 5.65148 8.5 5.49948 8.5Z",
    fill: "#7B481A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 12C9.69036 12 10.25 11.2165 10.25 10.25C10.25 9.2835 9.69036 8.5 9 8.5C8.30964 8.5 7.75 9.2835 7.75 10.25C7.75 11.2165 8.30964 12 9 12Z",
    fill: "#7B481A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 12C15.6904 12 16.25 11.2165 16.25 10.25C16.25 9.2835 15.6904 8.5 15 8.5C14.3096 8.5 13.75 9.2835 13.75 10.25C13.75 11.2165 14.3096 12 15 12Z",
    fill: "#7B481A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1448_136694",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12 12) rotate(90) scale(9)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE8AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCC4D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1448_136694"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(3 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWow);
export default __webpack_public_path__ + "static/media/wow.47a4bea685943bc8c39132ae7f25fb5c.svg";
export { ForwardRef as ReactComponent };